import Vue from 'vue'
import Vuex from 'vuex'

// global state, getters, actions, mutations
import state from './state.js'
import mutations from './mutations.js'
import * as getters from './getters.js'
import * as actions from './actions.js'

// modules
import home from './modules/home'
import map from './modules/map'
import mall from './modules/mall'
import member from './modules/member'
import building from './modules/building'
import resource from './modules/resource'
import communityShop from './modules/communityShop'

// plugins
import logger from './plugins/logger.js'
import createHttpInterceptor from './plugins/httpInterceptor.js'

Vue.use(Vuex)

const httpInterceptor = createHttpInterceptor()

const plugins = [httpInterceptor]
if (process.env.NODE_ENV === 'development') {
  plugins.push(logger)
}

export default new Vuex.Store({
  // global state
  state,
  // global getters
  getters,
  // global actions
  actions,
  // global plugins
  plugins,
  // global mutations
  mutations,
  modules: { home, map, mall, member, building, resource, communityShop }
})



// WEBPACK FOOTER //
// ./src/store/index.js